import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getShortlists, type GetShortlistsParams } from './shortlistsApi';

export const SHORTLISTS_QUERY_KEY = ['shortlists'] as const;

/**
 * Lista paginada de shortlists del cliente autenticado. `keepPreviousData` evita el
 * flash a skeleton al cambiar de página — la lista anterior queda visible mientras
 * la nueva se fetchea.
 *
 * staleTime corto (30s): las shortlists se comparten/revocan desde el panel del
 * recruiter sin notificar al cliente; refresh al volver al tab cubre la mayoría de
 * casos de actualización.
 */
export function useShortlists(params: GetShortlistsParams = {}) {
  return useQuery({
    queryKey: [...SHORTLISTS_QUERY_KEY, params.pageNumber ?? 1, params.pageSize ?? 20],
    queryFn: () => getShortlists(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
